import ExacqVisionVMS from "features/VMS/index.web";


export default function ExacqVisionVMSRoute() {
  return <ExacqVisionVMS />;
}
